import styled from 'styled-components';

import {
  TextField,
  Button,
} from '@mui/material';
import colors from '../../../../../styles/colors';

const ContentWrapper = styled.div`
  padding: 16px;
  height: 100%;
  width: 60%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  background-color: ${colors.base.gamma};
`;

const WelcomeMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 25px;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
`;

const StyledTextField = styled(TextField)`
  width: 100%;
`;

const StyledButton = styled(Button)`
  margin: 10px 0;
  width: 250px;
  text-transform: none;
`;

export {
  ContentWrapper,
  InputContainer,
  StyledTextField,
  StyledButton,
  WelcomeMessageContainer,
};
